export default __webpack_public_path__ + "static/media/blackLogo.935017ef.svg";